import { useState } from 'react';

import { FlexContainer } from '../../components/components.styled';
import { Body, Title } from '../../components/typography.styled';
import TextInput from '../../components/forms/text-input.component';
import OxPage from '../../components/oxpage.component';
import useUserSearch from '../../hooks/use-user-search';
import { ContentArea } from '../post/post.styled';
import UserListing from '../../components/user/user-listing.component';
import { SearchResultLinkArea } from './search.styled';
import LoadingSpinner from '../../components/basic/loading-spinner.component';

const SearchPage = () => {
    const [search, setSearch] = useState('');
    // const results = useSongSearch(search);
    const { results, loading } = useUserSearch(search);

    return (
        <OxPage>
            <ContentArea>
                <FlexContainer direction="column" align="center" justify="center">
                    <Title>Search for a User</Title>
                    <TextInput id="search" label="Start Typing" value={search} setValue={setSearch} />
                    {search === '' ? (
                        <>
                            <Body align="center" margin="0 0 16px 0">
                                (start typing to see search results)
                            </Body>
                        </>
                    ) : (
                        <>
                            {loading ? (
                                <LoadingSpinner />
                            ) : (
                                results.map((u) => (
                                    <SearchResultLinkArea to={`/user/${u.id}`}>
                                        <UserListing key={u.id} user={u} />
                                    </SearchResultLinkArea>
                                ))
                            )}
                        </>
                    )}
                </FlexContainer>
            </ContentArea>
        </OxPage>
    );
};

export default SearchPage;
